import { ReleaseType } from 'types/releases';
import { LabelV2VersionAudioFormLoader } from '../LabelV2VersionAudio';
import { SoundCloudVersionAudioLoader } from '../SoundCloudVersionAudio';

export const VersionAudioLoader = ({ type }: { type?: ReleaseType }) => {
  if (type === ReleaseType.SOUNDCLOUD) {
    return <SoundCloudVersionAudioLoader />;
  }

  return <LabelV2VersionAudioFormLoader />;
};
